export default "__VITE_ASSET__Dn8Oh_Lw__"